import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ProfileService } from '../profile.service';
import { ITransaction } from '../../../types';
import { SubscriptionComponent } from '../components/subscription/subscription.component';
import { ReceiptComponent } from '../components/receipt/receipt.component';

@Component({
  selector: 'profile-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SubscriptionComponent, ReceiptComponent]
})
export class ProfileSubscriptionsComponent {
  service = inject(ProfileService);
  receipts = signal<ITransaction[]>([]);

  constructor() { 
    afterNextRender(() => {
      this.service.getReceipts().subscribe({
        next: result => {
          this.receipts.set(result);
        },
        error: error => {
          this.service.toast.error('Failed to get past receipts');
        }
      });
    })
  }
}
